import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatToolbar } from '@angular/material/toolbar';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

export interface Fruit {
  name: string;
}

export interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-manager-add-group',
  templateUrl: './manager-add-group.component.html',
  styleUrls: ['./manager-add-group.component.scss'],
  standalone:true,
  imports: [CommonModule,MatFormField,MatToolbar,MatOption,MatSelect]
})
export class ManagerAddGroupComponent implements OnInit {
  options: FormGroup;
  foods: Food[] = [
    { value: 'steak-0', viewValue: '1' },
    { value: 'pizza-1', viewValue: '2' },
    { value: 'tacos-2', viewValue: '3' }
  ];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [
    { name: 'Tech' },
    { name: 'Computer' },
    { name: 'Awsome' },
  ];

  breadcrumbsArray: any = [
    "manager-client-list",
    "manager-users-site-group",
    "manager-site-group",
    "manager-add-group"
  ];
  pageRef: any;
  constructor(fb: FormBuilder, public router: Router, public activeRoute: ActivatedRoute) {
    this.options = fb.group({
      hideRequired: false,
      floatLabel: 'auto',
    });

    activeRoute.queryParams.subscribe(params => {
      this.pageRef = params['pageRef'];
      if (this.pageRef === 'edit-group') {
        this.breadcrumbsArray = [
          "manager-client-list",
          "manager-users-site-group",
          "manager-group-list",
          "manager-add-group"
        ];
      }
    });
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  ngOnInit() { }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.fruits.push({ name: value.trim() });
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  addDevice() {
    this.router.navigate(['/manager-add-group']);
  }

  saveDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    if(this.pageRef === 'edit-group'){
      this.router.navigate(['/manager-group-list'], navigationExtras);
    }else{
      this.router.navigate(['/manager-users-site-group'], navigationExtras);
    }
   
  }

}
